export const settings = [
  {
    label: "Container background",
    type: "background-color",
    selector: "container",
    value: "#ffffff"
  },
  {
    label: "Background",
    type: "background-color",
    selector: "background",
    value: "#101010"
  },
  {
    label: "Background image",
    type: "background-image",
    selector: "background",
    value: "url(//pages.convertkit.com/assets/rainier/bg.jpg)"
  },
  {
    label: "Background transparency",
    type: "opacity",
    selector: "background",
    value: "0.3"
  },

  {
    group: "header",
    type: "color",
    selector: "header",
    value: "#ffffff"
  },
  {
    group: "header",
    type: "font-size",
    selector: "header",
    value: 28
  },
  {
    group: "header",
    type: "font-weight",
    selector: "header",
    value: 700
  },

  {
    group: "content",
    type: "color",
    selector: "content",
    value: "#ffffff"
  },
  {
    group: "content",
    type: "font-size",
    selector: "content",
    value: 18
  },
  {
    group: "content",
    type: "font-weight",
    selector: "content",
    value: 400
  },

  {
    group: "field",
    type: "color",
    selector: "field",
    value: "#929292"
  },
  {
    group: "field",
    type: "border-color",
    selector: "field",
    value: "#E4E7EA"
  },
  {
    group: "field",
    type: "border-radius",
    selector: "field",
    value: 0
  },
  {
    group: "field",
    type: "font-weight",
    selector: "field",
    value: 400
  },

  {
    group: "button",
    type: "color",
    selector: "button",
    value: "#ffffff"
  },
  {
    group: "button",
    type: "background-color",
    selector: "button",
    value: "#c75c56"
  },
  {
    group: "button",
    type: "border-radius",
    selector: "button",
    value: 0
  },
  {
    group: "button",
    type: "font-weight",
    selector: "button",
    value: 700
  }
]
